import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteCropExploration, deleteCropExplorationTemplate } from "services";

import { DELETE_CROP_EXPLORATIONS, GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useDeleteCropExploration = (isAdmin: boolean = false) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_CROP_EXPLORATIONS],
    mutationFn: !isAdmin ? deleteCropExploration : deleteCropExplorationTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
